import React, { useState } from "react";
import { Row, Col, Button, Form } from "antd";
// import { useHistory } from "react-router-dom";
import imgOTP from "../../assets/images/otp-icon.png";
import OtpInput from "react-otp-input";
import { useFormik } from "formik";
import * as yup from "yup";

const initialValue = {
    otp: "",
};

const validationSchema = yup.object().shape({
    otp: yup.string(),
});

const FormItem = Form.Item;

function OTP(props) {
    const [loading, setLoading] = useState(false);

    

    const formik = useFormik({
        initialValues: initialValue,
        validationSchema,
        onSubmit: (values, helperFn) => {
            
            setLoading(true);
            if (typeof props?.onSubmit === "function")
                props.onSubmit(values.otp);
            setLoading(false);
        },
    });
    // const history = useHistory();

    const [counter, setCounter] = React.useState(30);
    React.useEffect(() => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }, [counter]);

    return (
        <Row gutter={[0, 25]} type="flex">
            <Col span={24} align="middle" justify="center">
                <div className="gx-app-logo">
                    <img src={imgOTP} alt="" />
                    <h2>Enter OTP</h2>
                    <p>Enter your email to receive an OTP</p>
                </div>
            </Col>
            <Col span={24}>
                <div className="gx-app-login-main-content">
                    <div className="gx-app-login-content">
                        <Form
                            initialValues={{ remember: true }}
                            name="basic"
                            onFinish={formik.handleSubmit}
                            className="gx-signin-form gx-form-row0"
                        >
                            <div className="resend-wrapper">
                                <OtpInput
                                    value={formik.values.otp}
                                    isInputNum={true}
                                    shouldAutoFocus={true}
                                    onChange={(e) => {
                                        formik.setFieldValue("otp", e);
                                    }}
                                    numInputs={4}
                                />

                                <p>Didn't receive the code?</p>
                                <Button
                                    type="primary"
                                    disabled={counter >= 1 ? true : false}
                                    // htmlType="submit"
                                    onClick={()=>{props.resendOTP();setCounter(30)}}
                                    
                                   
                                    className="resendCounter"
                                >
                                    {counter >= 1
                                        ? `Resend in ${counter} seconds`
                                        : "Resend OTP"}
                                </Button>
                            </div>

                            <FormItem>
                                <Button
                                    type="primary"
                                    className="gx-mb-0 butn"
                                    htmlType="submit"
                                    loading={loading}
                                    disabled={
                                        formik.values.otp.length >= 4
                                            ? false
                                            : true
                                    }
                                >
                                    Verify
                                </Button>
                            </FormItem>
                        </Form>
                    </div>
                </div>
            </Col>
        </Row>
    );
}

export default OTP;
